<template>

 <div>
    <div class="designer_head ellipsis">
       <span class="head_title gt-xs">{{ HeadTitle }}</span>
       <q-icon name="fas fa-paint-brush lt-sm" color='primary'/>
       <div class="head_count">{{ ordersCount }}</div>
       <div class="button_region">
            <div class="add_order" @click="addNewOrder">+</div>
            <div class="add_order toggle_button gt-xs" @click="toggleOrders">
                <img src="./assets/down_arrow.png" v-if="ordersVisible">
                <img src="./assets/right_arrow.png" v-if="!ordersVisible">
            </div>
       </div>
    </div>
    <q-slide-transition>
        <div class="ordersContainer q-pa-xs" v-if="ordersVisible" v-bind:class="{'q-pa-sm' : $q.screen.gt.sm}">

            <!-- <q-list highlight separator>   -->
                <designer-line v-for="(order) in designer_orders" 
                            :key="order.id" 
                            :order="order" 
                            :index='order.id'>
                </designer-line>
            <!-- </q-list> -->

        </div>
    </q-slide-transition>
    <!-- <add-order-dialog></add-order-dialog>   -->
 </div>

</template>

<script>
/* eslint-disable */
import DesignerLine from './DesignerLine_Layout'

import addOrderDialog from './addOrder';

// import { Modal } from 'bootstrap-vue/es/components';

export default {
    name : 'Designer-Orders',

    components : {
        DesignerLine,
        addOrderDialog
    },

    data () {
        return {
            HeadTitle: 'заказ у дизайнера',
            ordersVisible : true,
        }
    },
    
    computed: {

      designer_orders() {
           return this.$store.getters.designerOrders.sort(function(a,b) {
               if (a.id > b.id) return -1;
               if (a.id < b.id) return 1;
               if (a.id == b.id) return 0;
           });
      },
      
       ordersCount() {
          return this.$store.getters.designerOrders.length;
      }
    

    },
    
    methods : {
        toggleOrders() {
            this.ordersVisible = !this.ordersVisible;
        },

        addNewOrder() {
            
            eventBus.$emit('createNewOrder');

        }
    }

}
</script>

<style lang="scss" scoped>

@import url("https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css");

.designer_head {
        display: flex;
        align-items: center;
        animation-duration: 0.3s;
        height : 45px;
        background: rgba(255, 196, 0, 0.863);
        padding-left : 15px;

    .head_title {
        font-size:18px;
        color : black;
        padding-top : 15px;
        text-transform: uppercase; 
        white-space:  nowrap;
    }
    .head_count {
        margin-left:20px;
        background : rgb(255, 187, 0);
        min-width : 60px;
        height : 45px;
        font-size: 28px;
        font-weight: bold;
        padding-left: 10px;
        padding-right: 10px;
        padding-top : 8px;
        text-align: center;
    }
    .add_order {
        width : 80px;
        height : 45px;
        text-align: center;
        font-size: 40px;
        cursor: pointer;
        &:hover {
            background : rgb(255, 187, 0);
            color : rgb(4, 134, 4);
        }
    }
    .button_region {
        width : 100%;
        display : flex;
        justify-content : flex-end;
        
    }
}
.ordersContainer{
    border : 1px solid rgb(182, 182, 182);
    border-top : 0px;
    width : 100%;
    // height : 300px;
    animation-duration: 1s;
}





</style>

